export const userDefinedHandlersAndOpts = [
  "beforeReadOnlyChange",
  "defaultLinkedOligoMessage",
  "allowMultipleFeatureDirections",
  "getAdditionalEditAnnotationComps",
  "getAdditionalCreateOpts",
  "getLinkedOligoLink",
  "additionalTopRightToolbarButtons",
  "getCustomAutoAnnotateList",
  "allowPartsToOverlapSelf",
  "allowPrimerBasesToBeEdited",
  "truncateLabelsThatDoNotFit",
  "smartCircViewLabelRender",
  "on_setPanelAsActive",
  "on_propertiesViewTabUpdate",
  "onConfigureFeatureTypesClick",
  "allPartTags",
  "bpLimit",
  "editTagsLink",
  "readOnly",
  "shouldAutosave",
  "hideSingleImport",
  "beforeAnnotationCreate",
  "disableSetReadOnly",
  "allowAnnotationEditLocking",
  "disableBpEditing",
  "massageCmds",
  "showReadOnly",
  "showCircularity",
  "onHiddenEnzymeAdd",
  "showMoleculeType",
  "showAvailability",
  "showCicularViewInternalLabels",
  "showGCContentByDefault",
  "GCDecimalDigits",
  "onlyShowLabelsThatDoNotFit",
  "fullscreenMode",
  "maxAnnotationsToDisplay",
  "onNew",
  "onImport",
  "onSave",
  "onSaveAs",
  "alwaysAllowSave",
  "generatePng",
  "onRename",
  "getVersionList",
  "getSequenceAtVersion",
  "onDuplicate",
  "onSelectionOrCaretChanged",
  "beforeSequenceInsertOrDelete",
  "enzymeManageOverride",
  "enzymeGroupsOverride",
  "additionalEnzymes",
  "getAcceptedInsertChars",
  "maxInsertSize",
  "onDelete",
  "onCopy",
  "autoAnnotateFeatures",
  "autoAnnotateParts",
  "autoAnnotatePrimers",
  "onCreateNewFromSubsequence",
  "onPreviewModeFullscreenClose",
  "onPaste",
  "menuFilter",
  "showAminoAcidUnitAsCodon",
  "onBeforeExport"
];
